import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";
import { BulkActionsVariant } from "components/BulkActions/types";

import {
  AiIntegrationsBulkActionsAnalyticsPayload,
  AiIntegrationsBulkActionsConfirmActionStepProps,
  AiIntegrationsBulkActionItem,
  AiIntegrationsMutationVariables,
} from "../types";
import AiIntegrationsBulkActionsConfirmActionStepDefault from "./Default";

type AiIntegrationsBulkActionsConfirmActionFormProps = {
  action: AiIntegrationsBulkActionItem;
  variant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: AiIntegrationsMutationVariables,
    analyticsPayload: AiIntegrationsBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
};

const AiIntegrationsBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
}: AiIntegrationsBulkActionsConfirmActionFormProps) => {
  const props: AiIntegrationsBulkActionsConfirmActionStepProps = {
    bulkActionsVariant: variant,
    onConfirm,
    onCancel,
    action,
  };

  const actionComponent = <AiIntegrationsBulkActionsConfirmActionStepDefault {...props} />;

  return <BulkActionsConfirmActionStep>{actionComponent}</BulkActionsConfirmActionStep>;
};

export default AiIntegrationsBulkActionsConfirmActionForm;
